export function normalizeTimeSec(input: unknown): number | null {
  if (input == null) return null;

  if (typeof input === 'number' && Number.isFinite(input)) {
    return input > 10_000_000_000 ? Math.floor(input / 1000) : Math.floor(input);
  }

  if (typeof input === 'string') {
    const trimmed = input.trim();
    if (!trimmed) return null;
    const asNum = Number(trimmed);
    if (Number.isFinite(asNum)) return normalizeTimeSec(asNum);
    const parsed = Date.parse(trimmed);
    return Number.isFinite(parsed) ? Math.floor(parsed / 1000) : null;
  }

  if (input instanceof Date) {
    const ms = input.getTime();
    return Number.isFinite(ms) ? Math.floor(ms / 1000) : null;
  }

  if (typeof input === 'object') {
    const maybe = input as any;
    const ts = maybe?.timestamp;
    if (Number.isFinite(Number(ts))) return normalizeTimeSec(Number(ts));

    const year = Number(maybe?.year);
    const month = Number(maybe?.month);
    const day = Number(maybe?.day);
    if (Number.isFinite(year) && Number.isFinite(month) && Number.isFinite(day)) {
      return Math.floor(Date.UTC(year, month - 1, day) / 1000);
    }
  }

  return null;
}
